// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1rG-4","calendarButtons":"ClockData_calendarButtons__38r1g"};